/*eslint-disable*/
// chakra imports
import { Box} from "@chakra-ui/react";
import React from "react";
import SidebarContent from "./SidebarContent";


// FUNCTIONS

function Sidebar() {
  const mainPanel = React.useRef();
  let variantChange = "0.2s linear";
  let sidebarBg = "none";
  let sidebarRadius = "0px";
  let sidebarMargins = "0px";

  // SIDEBAR
  return (
    <Box ref={mainPanel}>
      <Box display={{ base: "none", xl: "block" }} position="fixed">
        <Box
          bg={sidebarBg}
          transition={variantChange}
          w="260px" maxW="260px"
          ms={{ sm: "16px", }}  my={{ sm: "16px", }}
          h="calc(100vh - 32px)"
          ps="20px" pe="20px"
          m={sidebarMargins}
          borderRadius={sidebarRadius}
        >
          <SidebarContent  logoText={"SURELLE DASHBOARD"}  />
        </Box>
      </Box>
    </Box>
  );
}




export default Sidebar;
